import React from "react";
import {
    Card,
    CardBody,
    Badge
} from "reactstrap";
import {
    Lock,
    Clock
} from "react-feather";

const QuestionLocked = ({ remainingTime }) => {

    const formatTime = (seconds) => {

        const min = Math.floor(seconds / 60);

        const sec = seconds % 60;

        return `${String(min).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;

    };

    return (

        <Card className="border-0 shadow">

            <CardBody className="text-center py-5">

                <div
                    className="bg-warning rounded-circle text-white d-inline-flex justify-content-center align-items-center"
                    style={{
                        width: 90,
                        height: 90
                    }}
                >

                    <Lock size={40} />

                </div>

                <h3 className="fw-bold mt-4">

                    Question Locked

                </h3>

                <p className="text-muted">

                    This question is not live yet.

                </p>

                <Badge
                    color="danger"
                    className="px-3 py-2"
                >

                    Starts In

                </Badge>

                <h1 className="mt-3 text-danger">

                    {formatTime(remainingTime)}

                </h1>

                <div className="mt-3 text-muted">

                    <Clock size={18} className="me-2" />

                    Please wait until the timer ends.

                </div>

            </CardBody>

        </Card>

    );

};

export default QuestionLocked;